import React, {forwardRef} from "react"
import './Button.less'

interface Props {
    title: string
    className?: string
    onClick: () => void
    disabled?: boolean
}

export const Button = forwardRef<HTMLButtonElement, Props>(({
                                                                title,
                                                                className,
                                                                onClick,
                                                                disabled = false,
                                                            }, ref) => {
    const clickButton = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        if (!disabled) {
            onClick()
        }
    }
    const classes = ['buttonWrapper']
    if (className) {
        classes.push(className)
    }
    if (disabled) {
        classes.push('disabled')
    }

    return (
        <button ref={ref} className={classes.join(' ')} onMouseDown={clickButton} disabled={disabled}>{title}</button>
    )
})
Button.displayName = 'Button'
